import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  'ゴルファー向けのアプリを開発いたしました。このアプリは、ストイックなアマチュアゴルファーを対象とし、ラウンド記録と分析に特化したアプリです。弊社はユーザーインタビューからペルソナ設計、ユースケースなどを考慮した結果、アプリコンセプトを再考し、リニューアルを実施しました。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/anchor/ogp_chor.png'

export const anchorPageMeta: PageMeta = {
  title: 'Ultra Caddy | 事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI モバイルアプリ システム化 DX推進 フロントエンド開発',
  image: ogpImg,
  url: `${SITE_URL}/cases/anchor/`,
}

export const anchorSchema = buildCaseStudySchema({
  slug: 'anchor',
  pageTitle: anchorPageMeta.title,
  description: anchorPageMeta.description,
  headline: 'Ultra Caddy',
  alternativeHeadline: '株式会社Anchor',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/caseStudyTop/anchor.webp'],
  clientName: '株式会社Anchor',
  breadcrumbLabel: 'Ultra Caddy',
})
